var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.38219 24 0 18.6178 0 12C0 5.38219 5.38219 0 12 0C18.6178 0 24 5.38219 24 12C24 18.6178 18.6178 24 12 24ZM12 1.28838C6.09454 1.28838 1.28838 6.09454 1.28838 12C1.28838 17.9055 6.09454 22.7116 12 22.7116C17.9055 22.7116 22.7116 17.9055 22.7116 12C22.7116 6.09454 17.9055 1.28838 12 1.28838Z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46828 15.1942C5.75295 13.9552 6.17862 12.3666 7.41761 11.6513L10.3158 9.97795L9.52103 8.60129L6.6228 10.2746C4.62301 11.4292 3.93705 13.9892 5.09162 15.989C6.2462 17.9888 8.80626 18.6748 10.806 17.5202L13.7043 15.8469L12.9095 14.4702L10.0112 16.1435C8.77223 16.8589 7.18362 16.4332 6.46828 15.1942ZM9.8573 14.2036L15.6538 10.857L14.8171 9.40791L9.02065 12.7545L9.8573 14.2036ZM13.8684 6.09134L10.9702 7.76464L11.765 9.1413L14.6632 7.46801C15.9022 6.75267 17.4908 7.17834 18.2061 8.41733C18.9215 9.65633 18.4958 11.2449 17.2568 11.9603L14.3586 13.6336L15.1534 15.0102L18.0516 13.3369C20.0514 12.1824 20.7374 9.6223 19.5828 7.62252C18.4282 5.62273 15.8682 4.93677 13.8684 6.09134Z",
    fill: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCopy);
export default __webpack_public_path__ + "static/media/LinkCopy.29a49b50.svg";
export { ForwardRef as ReactComponent };